import React from "react";
import { Dropdown } from "../../../Dropdown";
export const DropdownFilter = ({ options, selectedOption, onSelect, filterTitle, placeholder }) => (React.createElement("div", { className: "dropdown-filter" },
    React.createElement("label", null,
        filterTitle,
        React.createElement(Dropdown, { options: options, onSelect: onSelect, classes: "dropdown-filter__select", selectedOption: selectedOption, placeholder: placeholder, isPlaceholderDisabled: false, style: { backgroundColor: "#F2F6F6" } }))));
